import MDEditor from "@uiw/react-md-editor";
import {FC, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {Link, Theme} from "@mui/material"; // Assuming you're using MUI for Link
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import {SxProps} from "@mui/system"; // Localization for 'expand' and 'collapse'

interface IProps {
    source: string;
    loading?: boolean;
    color?: string;
    maxCharacters?: number;
    sx?: SxProps<Theme>
}

const safeTruncateMarkdown = (text: string, limit: number): string => {
    if (text.length <= limit) return text;

    let truncated = text.slice(0, limit);

    // Avoid cutting markdown syntax (bold, italic, links)
    truncated = truncated.replace(/(\*\*|\*|__|_|`|\[)\S*$/, "");

    return truncated + " ..."; // Add ellipsis to indicate truncation
};

const MarkdownWrapper: FC<IProps> = ({source, loading = false, color = "white", maxCharacters, sx}) => {
    const location = useLocation();
    const {t} = useTranslation()
    const [expanded, setExpanded] = useState(false)

    useEffect(() => {
        if (location.hash && !loading) {
            const elementId = location.hash.replace("#", "");
            const element = document.getElementById(elementId);

            if (element) {
                element.scrollIntoView({behavior: "smooth"});
            }
        }
    }, [location, loading]);

    // Display truncated content when collapsed
    const displayedContent = expanded || !maxCharacters ? source : safeTruncateMarkdown(source, maxCharacters);

    return (
        <Box sx={sx}>
            <MDEditor.Markdown style={{color: color, backgroundColor: "transparent"}} source={displayedContent}/>

            {/* Expand/Collapse Button */}
            {maxCharacters && source.length > maxCharacters && (
                <Link
                    sx={{color: color, cursor: "pointer", fontWeight: 600}}
                    onClick={() => setExpanded((expanded) => !expanded)}
                >
                    {expanded ? t('collapse') : t("expand")}
                </Link>
            )}
        </Box>
    );
};

export default MarkdownWrapper;
